<script lang="ts">
  import PoweredBy from "../../icons/PoweredBy.svg"
  import FooterLink from "./FooterLink.svelte"
</script>

<footer>
  <a href="https://www.gethumankind.com" target="_blank" aria-label="Humankind">
    <PoweredBy class="PoweredBy" />
  </a>
  <div class="footer-links-container">
    <FooterLink
      href="https://www.gethumankind.com/terms-of-service"
      label="Terms & Conditions"
    />
    <FooterLink
      href="https://www.gethumankind.com/privacy-policy"
      label="Privacy Policy"
    />
  </div>
</footer>

<style lang="scss">
  footer {
    border-top: 1px solid #e8e5d8;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 0 6px;
    height: 64px;
    margin-top: 32px;

    :global(.PoweredBy) {
      width: 119px;
      height: 32px;
    }
  }
</style>
